var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error !== null)?_c('v-alert',{attrs:{"type":"error","value":true,"dense":""}},[_vm._v(" "+_vm._s(_vm.$ft(_vm.error))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }